<template>
  <div>
    <AssignmentStripe />
    <ItemsArea v-if="itemsAreCreated" />
    <BatchCreatingItems v-else />
  </div>
</template>

<script lang="ts">
import type { Assignment } from '@/types/Models/Assignment'
import { computed, type ComputedRef, defineAsyncComponent, defineComponent } from 'vue'
import { VALIDATING, PENDING } from '@/const/AssignmentStatuses'
import { useAssignmentSummaryStore } from '@/store/assignmentSummary'
import BatchCreatingItems from '@/views/Assignments/Details/Batch/CreatingItems.vue'

export default defineComponent({
  name: 'BatchAssignmentDetails',
  components: {
    BatchCreatingItems,
    AssignmentStripe: defineAsyncComponent(() => import('@/views/Components/Assignment/Stripe/AssignmentStripe.vue')),
    ItemsArea: defineAsyncComponent(() => import('@/views/Assignments/Details/Batch/ItemsArea.vue')),
  },
  setup() {
    const assignmentSummaryStore = useAssignmentSummaryStore()

    const assignment: ComputedRef<Assignment> = computed(() => assignmentSummaryStore.assignment as Assignment)
    const itemsAreCreated = computed(() => ![PENDING, VALIDATING].includes(assignment.value.status))

    return {
      itemsAreCreated,
    }
  },
})
</script>
